import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { AuditLog } from '../+models/audit-log.model';

@Component({
  selector: 'sd-portal-audit-detail-list',
  templateUrl: './audit-detail-list.component.html',
  styleUrls: ['./audit-detail-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditDetailListComponent implements OnInit {
  // Inputs
  @Input() isTall: boolean = false;
  @Input() loading: boolean = false;
  @Input() loaded: boolean = true;
  @Input() audits: AuditLog[];
  @Input() noAuditsMessage: string = 'No audit records';

  // Outputs
  @Output() nextPage = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}
}
